import { axiosInstance } from "../../axiosConfig";

export default async function getStateCopies(cartIds: string[]) {
  try {
    const res = await axiosInstance.post(
      "/get_copies/Form",
      {
        history_id_array: cartIds,
        copy_type: "state copy",
      },
      {
        responseType: "blob",
      }
    );
    return { data: res.data, header: res.headers };
  } catch (err) {
    throw err;
  }
}
